<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100"
                    fixed-header height="calc(100vh - 300px)">
                    <template v-slot:item="{ item }">
                        <tr :style="getPackHighlightStyle(item)">
                            <!-- <td>{{ item.OrderCode }}</td> -->
                            <td>{{ item.LicensePlate }}</td>
                            <td>{{ item.LicensePlateVN }}</td>
                            <td>{{ item.OrderDate | display_date }}</td>
                            <td>{{ item.TranferDate | display_date }}</td>
                            <td>{{ item.ReleaseTruckDate | display_date }}</td>
                            <td>{{ item.StoreDate | display_date }}</td>
                            <td class="text-right">{{ getTotalNumberOfPack(item) | currency }}</td>
                            <td class="text-right">{{ item.ImportedNumberOfPack | currency }}</td>
                            <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                            <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                            <td :style="{'color': getStatusColor(item.Status)}">{{ item.Status | display_value(receive_type_list) }}</td>
                            <td class="text-center">
                                <table-action-buttons :actions="getItemActions(item)"></table-action-buttons>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "order_list",
            headers: [
                // {
                //     text: this.$t('table_headers.order_code'),
                //     value: "OrderCode",
                //     filterable: true,
                //     quickSearch: true,
                //     dataType: configs.DATA_TYPE["String"]
                // },
                {
                    text: this.$t('table_headers.license_plate'),
                    value: "LicensePlate",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.license_plate_vn'),
                    value: "LicensePlateVN",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.truck_date'),
                    value: "OrderDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.tranfer_date'),
                    value: "TranferDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.release_date'),
                    value: "ReleaseTruckDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.warehouse_date'),
                    value: "StoreDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: 'Tổng kiện',
                    value: "TotalNumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Tổng kiện nhận',
                    value: "ImportedNumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.weight'),
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.volume'),
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.status'),
                    value: "Status",
                    filterable: true,
                    values: configs.RECEIVE_TYPE_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.action'),
                    value: "",
                    width: "100px",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            receive_type_list: configs.RECEIVE_TYPE_LIST
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.order.all.data,
            total_rows: state => state.order.all.total,
            loading: state => state.order.loading,
            currentItem: state => state.order.selected,
            customers: state => state.commons.customers,
        }),
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        }
    },
    methods: {
        getItemActions(item) {
            return [
                { label: this.$t('actions.edit'), variant: 'primary', onClick: () => this.openItem(item.ID) },
                { label: this.$t('actions.delete'), variant: 'danger-outline', onClick: () => this.deleteItem(item.ID) }
            ];
        },
        filter_data: function () {
            let currentFilter = JSON.parse(JSON.stringify(this.filterConditions));
            currentFilter.push({
                column: "Status",
                value: [5],
                condition: "in"
            });
            var param = {
                pagination: this.pagination,
                filter: currentFilter,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("order/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        newItem: function () {
            this.$store.commit("order/setDetail", { 'ID': 0 });
            let route = this.$router.resolve({
                name: "TruckDetail",
                params: { Pid: 'new', title: `Đơn hàng mới` }
            });
            window.open(route.href, '_blank');
        },
        openItem: function (id) {
            let route = this.$router.resolve({
                name: "ImportVNDetail",
                params: { Pid: id, title: `Chi tiết nhập kho VN (#${id})` }
            });
            window.open(route.href, '_blank');
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        exportData() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("order/exportList", param);
        },
        getTotalNumberOfPack(item) {
            return Number(item.TotalNumberOfPack || 0);
        },
        isIncompletePack(item) {
            return Number(item.ImportedNumberOfPack || 0) < this.getTotalNumberOfPack(item);
        },
        getPackHighlightStyle(item) {
            if (!this.isIncompletePack(item)) {
                return {};
            }
            return {
                backgroundColor: '#fff3cd'
            };
        },
        getStatusColor(value) {
            const status = this.receive_type_list.find(item => item.value === value);
            return status ? status.color : '';
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.newItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("order/removeDetail", id);
        });
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.newItem);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_EXPORT_ACTION");
    }
};
</script>
